import { useQuery } from '@tanstack/react-query';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { getGuestLifetimeSpend } from 'restaurantAdmin/guestBook/apiHelpers';
import { useFeatureFlagContext } from 'restaurantAdmin/featureFlags';

export const guestLifetimeSpendQueryKey = (
  restaurantId: string,
  guestId: string,
) => ['restaurants', restaurantId, 'guests', guestId, 'lifetimeSpend'] as const;

export const useGuestLifetimeSpend = (guestId: string) => {
  const { id: restaurantId } = useRestaurant();
  const { isEnabled } = useFeatureFlagContext();

  return useQuery({
    queryKey: guestLifetimeSpendQueryKey(restaurantId, guestId),
    queryFn: async () => getGuestLifetimeSpend(restaurantId, guestId),
    // Every restaurant: one without Lightspeed shows N/A for food and beverage.
    enabled: isEnabled('lightspeedIntegration'),
  });
};
